/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type LocationFilterSchemaScope = typeof LocationFilterSchemaScope[keyof typeof LocationFilterSchemaScope];


export const LocationFilterSchemaScope = {
  c: 'c',
  p: 'p',
  cp: 'cp',
} as const;
